export default {
  init() {
    this.initHandlers();
  },

  initHandlers() {
    const $form = $('.j-form-edit-dependencies');

    const updateButtonStates = select => {
      const selectAllButton = select.closest('.select-wrapper').querySelector('#select_all');
      const clearAllButton = select.closest('.select-wrapper').querySelector('#clear_all');
      const options = Array.from(select.options).filter(option => !option.classList.contains('d-none'));

      const allSelected = options.every(option => option.selected);
      const anySelected = options.some(option => option.selected);

      if (selectAllButton) {
        selectAllButton.disabled = !!allSelected;
      }

      if (clearAllButton) {
        clearAllButton.disabled = !anySelected;
      }
    };

    $('option').mousedown(function (e) {
      e.preventDefault();
      const $parent = $(this).parent();
      const originalScrollTop = $parent.scrollTop();
      $(this).prop('selected', !$(this).prop('selected'));
      $parent.focus();
      setTimeout(() => $parent.scrollTop(originalScrollTop), 0);
      updateButtonStates($parent[0]);
      return false;
    });

    document.querySelectorAll('select').forEach(select => {
      select.addEventListener('change', () => updateButtonStates(select));
      updateButtonStates(select);
    });

    document.querySelectorAll('#select_all').forEach(button => {
      button.addEventListener('click', () => {
        const select = button.closest('.select-wrapper').querySelector('select');
        Array.from(select.options).forEach(option => {
          if (!option.classList.contains('d-none')) {
            option.selected = true;
          }
        });
        updateButtonStates(select);
      });
    });

    document.querySelectorAll('#clear_all').forEach(button => {
      button.addEventListener('click', () => {
        const select = button.closest('.select-wrapper').querySelector('select');
        Array.from(select.options).forEach(option => {
          option.selected = false;
        });
        updateButtonStates(select);
      });
    });

    $form.on('submit', e => {
      e.preventDefault();
      $form.find("option:contains('__none_selected')").each((index, item) => {
        $(item).prop('selected', true);
        $(item).attr('selected', 'selected');
      });
      $form.off('submit');
      $form.submit();
    });
  },
};
